import { Box, Container, Grid, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { icons, images, videos } from "../../assets";
import { allColors } from "../../constants";
import GlobalButton from "./../../components/globalButton/index";
import { mediaUrl } from "../../constants/variables";
// import ReactPlayer from "react-player";

// Single card data - no more array
const cardData = {
  title: "Simplifying payments at competitive rates.",
  description:
    "Trust Card provides secure, affordable card payment solutions tailored to your business. Whether you’re a startup or an established business, our packages deliver the flexibility, reliability and cost savings you need to take payments with ease",
  price: "£16.99",
  bgColor: "linear-gradient(to right, #FFDA7A, #FFFFFF)",
  sideImge: images.multiMobileImg,
  respImg: images.multiMobileImg,
  cornerText: "No PCI compliance fees ever",
  cornerCircleColor: "#FF914D",
  uniqueId: "multi-mobile",
  showVideo: false,
};

const CardBannerSection = () => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (
    <Container
      sx={{
        maxWidth: "1300px !important",
        marginTop: "180px",
        position: "relative",
      }}
    >
      <Box
        sx={{
          backgroundImage: cardData.bgColor,
          borderRadius: "35px",
          marginTop: "60px",
          padding: "30px 0px 0px 0px",
        }}
      >
        <Box
          sx={{
            background: cardData.cornerCircleColor,
            borderRadius: "50%",
            width: { xs: "90px", md: "120px" },
            height: { xs: "90px", md: "120px" },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "15px",
            position: "absolute",
            left: { xs: false, sm: "55px" },
            right: { xs: "0px", sm: false },
            top: { xs: "-60px", sm: "-77px" },
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "15px", md: "19px" },
              color: allColors.jetBlack,
              fontFamily: "Raleway",
              fontWeight: "600",
              lineHeight: "normal",
              textAlign: "center",
            }}
          >
            {cardData.cornerText}
          </Typography>
        </Box>

        {/* <Typography
          sx={{
            fontSize: { xs: "40px", md: "20px" },
            color: allColors.jetBlack,
            fontFamily: "Raleway",
            fontWeight: "600",
            marginTop: "15px",
            lineHeight: { xs: "40px", sm: "40px" },
            textAlign: "left",
            display: { xs: "block", sm: "none" },
            marginLeft: "28px",
            width: "70%",
          }}
        >
          {cardData.title}
        </Typography> */}

        <Grid
          container
          spacing={{ xs: 0, md: 3 }}
          alignItems={{ xs: "flex-start", sm: "center" }}
          flexWrap={"wrap-reverse"}
          sx={{
            padding: { xs: "30px 0px 10px", md: "0px 40px" },
          }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            textAlign={"left"}
            mb={{ sm: 1, md: 3 }}
            sx={{ padding: { xs: "20px 20px", md: "0" } }}
          >
            <Typography
              sx={{
                fontSize: { xs: "30px", sm: "40px", md: "40px" },
                color: allColors.jetBlack,
                fontFamily: "Raleway",
                fontWeight: "600",
                marginTop: { xs: "0px", sm: "20px" },
                lineHeight: { xs: "35px", sm: "40px" },
                textAlign: "left",
                mb: { xs: "10px", md: "10px" },
              }}
            >
              {cardData.title}
            </Typography>
            <Typography
              sx={{
                marginLeft: { xs: "0", sm: 0 },
                fontSize: { xs: "15px", sm: "18px" },
                color: allColors.jetBlack,
                fontWeight: "500",
                fontFamily: "Raleway",
                lineHeight: { xs: "25px", sm: "33px" },
              }}
            >
              {cardData.description}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            textAlign={"center"}
            height={{ sm: "auto", md: 400 }}
            paddingTop={10}
            sx={{ padding: { xs: "0 20px", md: "0" } }}
          >
            <img
              src={isSmallScreen ? cardData.respImg : cardData.sideImge}
              style={{
                width: isSmallScreen ? "72%" : "95%",
                height: isSmallScreen ? "50%" : "330px",
                paddingTop: isSmallScreen ? "10px" : "50px",
              }}
              alt={cardData.sideImge}
            />
          </Grid>
        </Grid>

        <Box
          sx={{
            display: "flex",
            gap: "10px",
            justifyContent: { sm: "center", md: "flex-start" },
            alignItems: "center",
            width: { sm: "90%", md: "35%" },
            paddingBottom: "20px",
            margin: { xs: "0 0 20px 0", sm: "0px 0 0px 0" },
            ml: { sm: "0", md: "20px" },
          }}
        >
          <a
            href={"#contact-us"}
            style={{
              width: "100%",
              marginLeft: "10px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <GlobalButton
              title={"Switch today"}
              style={{
                background: allColors.white,
                color: allColors.jetBlack,
                borderRadius: "10px",
                height: { xs: 40, sm: 50 },
                px: { xs: "15px", sm: "22px" },
                width: "70%",
              }}
            />
          </a>
          {/* <a href={`#${cardData.uniqueId}`} style={{ width: "100%" }}>
            <GlobalButton
              title={"Show more"}
              style={{
                background: "none",
                borderRadius: "30px",
                height: { xs: 40, sm: 50 },
                px: { xs: "15px", sm: "22px" },
                border: `1px solid ${allColors.jetBlack}`,
                color: allColors.jetBlack,
                width: "100%",
              }}
            />
          </a> */}
        </Box>
      </Box>
    </Container>
  );
};

export default CardBannerSection;
